var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[(_vm.$loading.isLoading)?_c('div',{staticClass:"custom-loader"},[_c('div',{staticClass:"custom-loader-container"},[_c('div',{staticClass:"custom-loader-content"},[_c('p',[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"})])])])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }